module.exports = __webpack_public_path__ + "img/CurvedLogisticRegression.cffce061.png";